import LinearProgress from "@material-ui/core/LinearProgress";
import { useStyles } from "../../style";
import UploadIcon from "../../../../Assets/images/upload-big-arrow.svg";

const GSTItemsUploadingModal = () => {
  const classes: any = useStyles();

  return (
    <div className="flex flex-column justify-center items-center ds-mt46">
      <img src={UploadIcon} width={64} height={64} />
      <p className="mv0 ds-pt16 fw6 md-text24">Uploading...</p>
      <div className={classes.linearProgressContainer}>
        <LinearProgress className={classes.linearProgress} />
      </div>
      <p className="mv0 ds-pt12 md-text15 fw4 ds-c797A7C">
        It will take 2-10 mins. It will upload in the background. We will let you
      </p>
      <p className="mv0 md-text15 fw4 ds-c797A7C">know once done.</p>
    </div>
  );
};

export default GSTItemsUploadingModal;
